document.addEventListener('click', (event) => {
  const quantityButton = event.target.closest('[data-bv2-quantity]');
  if (quantityButton) {
    const input = quantityButton.closest('.bv2-qty').querySelector('input');
    const next = Number(input.value || input.min || 0) + Number(quantityButton.dataset.bv2Quantity) * Number(input.step || 1);
    input.value = Math.max(Number(input.min || 0), Math.min(Number(input.max || 99), next));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  const thumbnail = event.target.closest('[data-bv2-gallery-src]');
  if (thumbnail) {
    const gallery = thumbnail.closest('[data-bv2-gallery]');
    const image = gallery.querySelector('[data-bv2-main-image]');
    image.src = thumbnail.dataset.bv2GallerySrc;
    image.removeAttribute('srcset');
    image.alt = thumbnail.dataset.bv2GalleryAlt;
    image.closest('.bv3-product-stage').dataset.bvqView = thumbnail.dataset.bvqMode || 'pouch';
    const fullArtwork = gallery.querySelector('[data-bv2-gallery-full]');
    if (fullArtwork) fullArtwork.href = thumbnail.dataset.bv2GalleryOriginal || thumbnail.dataset.bv2GallerySrc;
    gallery.querySelectorAll('[data-bv2-gallery-src]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
  }
  if (event.target.closest('.bv2-mobile-panel a')) {
    event.target.closest('details').open = false;
  }
});

// Keep the custom header count in sync with Shopify cart updates and back navigation.
(function () {
  const cartLink = document.querySelector('.bv2-cart');
  if (!cartLink) return;
  function updateCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    cartLink.querySelector('[data-bv-cart-count]').textContent = count;
    cartLink.setAttribute('aria-label', `Cart, ${count} ${count === 1 ? 'item' : 'items'}`);
  }
  async function refreshCount() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers: {Accept: 'application/json'}});
      if (response.ok) updateCount((await response.json()).item_count);
    } catch (_) { /* Keep the server-rendered count if the request fails. */ }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (Number.isInteger(event.cartData?.item_count)) updateCount(event.cartData.item_count);
      else refreshCount();
    });
  }
  addEventListener('bv:cart-updated', refreshCount);
  addEventListener('pageshow', event => { if (event.persisted) refreshCount(); });
})();

(function(){
 const ritualStates = new WeakMap();
 function showRitual(box, step, scrollProgress = null) {
  const visual = box.querySelector('.bv-ritual-visual');
  const changed = Number(visual.dataset.step) !== step;
  visual.dataset.step = step;
  const liquid = box.querySelector('.bv-comic-liquid');
  if (scrollProgress !== null) {
   visual.setAttribute('data-scroll-fill', '');
   visual.style.setProperty('--liquid-top', `${88 - 70 * scrollProgress}%`);
   liquid?.classList.remove('is-filling');
  } else {
   visual.removeAttribute('data-scroll-fill');
   if (liquid) { liquid.classList.remove('is-filling'); if (step === 1) { void liquid.offsetWidth; liquid.classList.add('is-filling'); } }
  }
  if (changed) {
   box.querySelector('.bv-ritual-word').textContent = ['OPEN.','MIX.','ENJOY.'][step];
  }
  box.querySelectorAll('[data-bv-step]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.bvStep) === step)));
 }
 document.addEventListener('click', e => {
  const btn = e.target.closest('[data-bv-step]'); if (!btn) return;
  const box = btn.closest('[data-bv-ritual]');
  const state = ritualStates.get(box);
  if (state) state.manualY = scrollY;
  showRitual(box, Number(btn.dataset.bvStep));
 });
 const ritualMotion = matchMedia('(prefers-reduced-motion: reduce)');
 document.querySelectorAll('.bv-ritual-wide').forEach(section => {
  const box = section.querySelector('[data-bv-ritual]');
  const state = {manualY:null}; ritualStates.set(box,state);
  let queued = false;
  function update() {
   queued = false;
   if (ritualMotion.matches) return;
   if (state.manualY !== null) { if (Math.abs(scrollY-state.manualY)<48) return; state.manualY=null; }
   const rect = section.getBoundingClientRect();
   const distance = Math.max(1,section.clientHeight-box.offsetHeight-32);
   const progress = Math.max(0,Math.min(1,(16-rect.top)/distance));
   const step = progress < .25 ? 0 : progress < .78 ? 1 : 2;
   const fill = Math.max(0,Math.min(1,(progress-.25)/.48));
   showRitual(box,step,step===1?fill:null);
  }
  function queue() { if (!queued) { queued=true; requestAnimationFrame(update); } }
  function configure() {
   section.classList.toggle('is-scroll-driven',!ritualMotion.matches);
   state.manualY=null;
   if (ritualMotion.matches) showRitual(box,0); else queue();
  }
  addEventListener('scroll',queue,{passive:true}); addEventListener('resize',queue);
  ritualMotion.addEventListener('change',configure); configure();
 });
 const reduce=matchMedia('(prefers-reduced-motion: reduce)');const scenes=[...document.querySelectorAll('[data-bv-scene]')];let scheduled=false;
 function paint(){scheduled=false;if(reduce.matches)return;scenes.forEach(el=>{const r=el.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;const progress=Math.max(-1,Math.min(1,(innerHeight/2-r.top-r.height/2)/innerHeight));el.style.setProperty('--travel',String(progress));});}
 addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(paint)}},{passive:true});paint();
 document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.bv2-mobile-menu[open]').forEach(d=>d.open=false)});
})();

// Links to nutrition open the requested disclosure as well as scrolling to it.
(function () {
  function revealLinkedDetails() {
    const target = document.getElementById(location.hash.slice(1));
    if (target && target.tagName === 'DETAILS') target.open = true;
  }
  revealLinkedDetails();
  addEventListener('hashchange', revealLinkedDetails);
})();

// Each card adds complete units to the same Shopify cart, without clearing it.
(function () {
  const money = cents => new Intl.NumberFormat('en-US', {style: 'currency', currency: window.Shopify?.currency?.active || 'ZAR', currencyDisplay: 'narrowSymbol', minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2}).formatToParts(cents / 100).map(part => part.type === 'literal' && !part.value.trim() ? '' : part.value).join('');
  const count = input => Math.max(0, Math.min(99, Math.floor(Number(input.value) || 0)));
  function syncOrder(form) {
    form.querySelectorAll('.bv7-order-choice').forEach(card => {
      const choice = card.querySelector('[data-bv7-order]');
      const input = card.querySelector('[data-bv-card-quantity]');
      const quantity = count(input);
      const pricedQuantity = Math.max(1, quantity);
      const subscription = choice.dataset.bv7Order === 'subscription';
      card.querySelectorAll('[data-bv2-quantity]').forEach(button => {
        button.disabled = form.dataset.submitting === 'true' || (Number(button.dataset.bv2Quantity) < 0 ? quantity <= 0 : quantity >= 99);
      });
      input.disabled = form.dataset.submitting === 'true';
      if (subscription) {
        const pouches = pricedQuantity * Number(choice.dataset.pouches);
        card.querySelector('[data-sub-servings]').textContent = `${pouches * 20} servings every ${choice.dataset.days} days`;
        card.querySelector('[data-sub-pouches]').textContent = `${pouches} ${pouches === 1 ? 'pouch' : 'pouches'}`;
        card.querySelector('[data-sub-first]').textContent = money(Number(choice.dataset.firstUnit) * pricedQuantity);
        card.querySelector('[data-sub-renewal]').textContent = money(Number(choice.dataset.renewalUnit) * pricedQuantity);
      } else {
        card.querySelector('.bv7-choice-price').textContent = money(Number(choice.dataset.firstUnit) * pricedQuantity);
      }
      const submit = card.querySelector('[data-bv-card-add]');
      const unavailable = subscription && (choice.dataset.planAvailable !== 'true' || !choice.dataset.variantId);
      const status = submit.dataset.prelaunch === 'true' || unavailable ? 'Coming soon' : choice.dataset.stockAvailable !== 'true' ? 'Sold out' : '';
      submit.disabled = form.dataset.submitting === 'true' || quantity < 1 || !!status;
      if (form.dataset.submitting !== 'true') submit.textContent = 'Add to Cart';
      card.querySelector('[data-bv-card-availability]').textContent = status;
      card.querySelector('[data-bv-card-availability]').hidden = !status;
    });
  }
  document.querySelectorAll('.bv2-purchase-form').forEach(form => {
    form.noValidate = true; // Validate only the card being added.
    const requestedSupply = new URLSearchParams(window.location.search).get('bv_supply');
    const requested = ['20', '60'].includes(requestedSupply) ? form.querySelector(`[data-bv7-order="subscription"][data-days="${requestedSupply}"]`) : null;
    const featured = requested || form.querySelector('[data-bv7-order="subscription"]');
    if (featured) featured.checked = true;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.submitting === 'true') return;
      const card = event.submitter?.closest('.bv7-order-choice') || form.querySelector('[data-bv7-order]:checked')?.closest('.bv7-order-choice');
      if (!card) return;
      const choice = card.querySelector('[data-bv7-order]');
      choice.checked = true;
      syncOrder(form);
      const submit = card.querySelector('[data-bv-card-add]');
      const quantityInput = card.querySelector('[data-bv-card-quantity]');
      if (submit.disabled || !quantityInput.reportValidity()) return;
      const item = {id: choice.dataset.variantId, quantity: count(quantityInput)};
      if (choice.dataset.bv7Order === 'subscription') item.selling_plan = choice.value;
      const error = form.querySelector('[data-bv-order-error]');
      const feedback = form.querySelector('[data-bv-cart-feedback]');
      error.hidden = true; feedback.hidden = true;
      form.dataset.submitting = 'true'; syncOrder(form); submit.textContent = 'Adding…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [item]})
        });
        const result = await response.json();
        if (!response.ok) {
          error.textContent = result.description || 'Unable to add this item. Please check availability.';
          error.hidden = false;
        } else {
          feedback.replaceChildren(document.createTextNode(`${item.quantity} ${item.quantity === 1 ? 'item' : 'items'} added. Add another option or `));
          const link = document.createElement('a'); link.href = form.querySelector('[name="return_to"]').value;
          link.textContent = 'View Cart'; feedback.append(link); feedback.hidden = false;
          window.dispatchEvent(new Event('bv:cart-updated'));
        }
        form.dataset.submitting = 'false'; syncOrder(form);
      } catch (_) {
        // A lost response may still have added the item. Avoid an accidental duplicate.
        error.replaceChildren(document.createTextNode('We could not confirm your basket. '));
        const link = document.createElement('a'); link.href = form.querySelector('[name="return_to"]').value;
        link.textContent = 'Check your basket before trying again.'; error.append(link); error.hidden = false;
        submit.textContent = 'Check your basket';
      }
    });
    function update(event) {
      if (event.target.matches('[data-bv-card-quantity]')) {
        event.target.closest('.bv7-order-choice').querySelector('[data-bv7-order]').checked = true;
      }
      if (event.target.matches('[data-bv7-order], [data-bv-card-quantity]')) syncOrder(form);
    }
    form.addEventListener('change', update);
    form.addEventListener('input', update);
    syncOrder(form);
  });
})();

// A calm, user-controlled highlights carousel on small screens.
document.querySelectorAll('[data-bv-highlights]').forEach(carousel => {
  const labels = ['Zero sugar', 'Four essential electrolytes', 'Family-friendly', 'Hydrate your body'];
  const copy = carousel.querySelector('[data-highlight-copy]');
  const dots = [...carousel.querySelectorAll('[data-highlight-index]')];
  let current = 0;
  function show(index) {
    current = (index + labels.length) % labels.length;
    copy.textContent = labels[current];
    dots.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
  }
  carousel.querySelector('[data-highlight-prev]').addEventListener('click', () => show(current - 1));
  carousel.querySelector('[data-highlight-next]').addEventListener('click', () => show(current + 1));
  dots.forEach(button => button.addEventListener('click', () => show(Number(button.dataset.highlightIndex))));
  carousel.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  let touchStart = null;
  carousel.addEventListener('touchstart', event => { touchStart = [event.changedTouches[0].clientX, event.changedTouches[0].clientY]; }, { passive: true });
  carousel.addEventListener('touchend', event => {
    if (!touchStart) return;
    const dx = event.changedTouches[0].clientX - touchStart[0];
    const dy = event.changedTouches[0].clientY - touchStart[1];
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
    touchStart = null;
  }, { passive: true });
  carousel.closest('.bv-highlights').classList.add('is-enhanced');
});


// Reveal the excluded ingredients once, in reading order, when they enter view.
(function () {
  const sections = document.querySelectorAll('.bv-leave-out');
  if (!sections.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    sections.forEach(section => section.classList.add('is-crossed-out'));
    return;
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.closest('.bv-leave-out').classList.add('is-crossed-out');
      observer.unobserve(entry.target);
    });
  }, {threshold: 0.35});
  sections.forEach(section => observer.observe(section.querySelector('.bv-leave-out-list')));
})();
